var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.467,371.2h-25.6V106.667c0-14.114-11.486-25.6-25.6-25.6H59.733c-14.114,0-25.6,11.486-25.6,25.6V371.2h-25.6 c-4.71,0-8.533,3.823-8.533,8.533v25.6c0,14.114,11.486,25.6,25.6,25.6h460.8c14.114,0,25.6-11.486,25.6-25.6v-25.6 C512,375.023,508.177,371.2,503.467,371.2z M68.267,337.067h25.6V200.533h51.2v-51.2h68.267v76.8h34.133v-51.2h51.2V115.2h68.267 v34.133h51.2v187.733h25.6c4.71,0,8.533,3.823,8.533,8.533c0,4.71-3.823,8.533-8.533,8.533h-25.6h-51.2h-17.067h-34.133h-17.067 h-34.133h-17.067h-34.133h-17.067h-34.133h-17.067h-51.2h-25.6c-4.71,0-8.533-3.823-8.533-8.533 C59.733,340.89,63.556,337.067,68.267,337.067z M494.933,405.333c0,4.702-3.831,8.533-8.533,8.533H25.6 c-4.702,0-8.533-3.831-8.533-8.533v-17.067h25.6H179.2v8.533c0,4.71,3.823,8.533,8.533,8.533h136.533 c4.71,0,8.533-3.823,8.533-8.533v-8.533h136.533h25.6V405.333z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.333,
    y: 243.2,
    width: 34.133,
    height: 93.867
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.267,226.133 196.267,166.4 162.133,166.4 162.133,200.533 162.133,337.067 196.267,337.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.667,192 264.533,192 264.533,226.133 264.533,337.067 298.667,337.067  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.933,
    y: 217.6,
    width: 34.133,
    height: 119.467
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.933,
    y: 166.4,
    width: 34.133,
    height: 170.667
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.1c9d6cc9611723e45cd4963f02850c38.svg";
export { ForwardRef as ReactComponent };